import { useAppSelector } from 'application/providers/StoreProvider';
import { selectUserId } from 'application/store/slices/accountSlice/selectors';

export const useAccountUserId = () => {
  const userId = useAppSelector(selectUserId);

  return userId;
};
